<template>
  <v-app class="bgLightGreen" id="inspire">
    <Header back header-text="lng_payment_administ_title"></Header>
    <v-container fluid fill-height>
      <v-flex>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 pa-3 login-block">
              <v-card-text>
                <v-layout column align-center>
                  <h2 class="headingColor--text text-xs-center mb-4">
                    {{ "lng_view_invoice_text" | translate }}
                  </h2>

                  <v-layout>
                    <v-flex xs12 sm6 md8>
                      <p>{{ "lng_start_date_text" | translate }}</p>
                      <v-flex xs12 sm10 md10>
                        <v-menu
                          ref="startDateModal"
                          v-model="startDateModal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="startDate"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="startDate"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="startDate"
                            :max="currentDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              flat
                              color="primary"
                              @click="startDateModal = false"
                              >Cancel</v-btn
                            >
                            <v-btn flat color="primary" @click="changeStartDate"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-flex>

                    <v-flex xs12 sm6 md8>
                      <p>{{ "lng_end_date_text" | translate }}</p>
                      <v-flex xs12 sm10 md10>
                        <v-menu
                          ref="endDateModal"
                          v-model="endDateModal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="endDate"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="endDate"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="endDate"
                            :max="currentDate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              flat
                              color="primary"
                              @click="endDateModal = false"
                              >Cancel</v-btn
                            >
                            <v-btn flat color="primary" @click="changeEndDate"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-btn
                    color="primary"
                    class="mt-4"
                    :loading="showLoading"
                    @click="ViewInvoices"
                    >{{ "lng_view_invoice_btn_text" | translate }}</v-btn
                  >
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
  </v-app>
</template>
<script>
import Header from "../components/Header";
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service";
import moment from "moment";
import router from "../router.js";

export default {
  name: "PaymentAdministration",
  components: {
    Header
  },
  data: () => ({
    currentDate: new Date().toISOString().substr(0, 10),
    startDate: new Date().toISOString().substr(0, 10),
    startDateModal: false,
    endDate: new Date().toISOString().substr(0, 10),
    endDateModal: false,
    expiryDate: undefined,
    showLoading: false
  }),
  created() {
    this.expiryDate = localStorage.getItem("expirydate");
  },
  mounted() {},
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    changeStartDate() {
      this.$refs.startDateModal.save(this.startDate);
    },
    changeEndDate() {
      this.$refs.endDateModal.save(this.endDate);
    },
    async ViewInvoices() {
      if (new Date(this.startDate) <= new Date(this.endDate)) {
        // console.log('if =======: ', this.startDate, this.endDate);
        this.showLoading = true;
        // let data = await GlobalService.getAllPayments(
        //   this.getUser.token,
        //   this.startDate,
        //   this.endDate
        // );

        this.$http({
          method: "get",
          url: "http://www.principlesofeconometrics.com/excel/cola.xls",
          responseType: "blob",
          headers: { Accept: "application/vnd.ms-excel" }
        })
          .then(response => {
            console.log("-========: ", response);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.xls"); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => console.log("error occured: ", err));

        // axios({
        //   url: 'http://www.principlesofeconometrics.com/excel/cola.xls',
        //   method: 'GET',
        //   responseType: 'blob', // important
        //   headers: { 'Accept': 'application/vnd.ms-excel' }
        // }).then((response) => {
        //   console.log('kkkkkkk: ', response);
        //   const url = window.URL.createObjectURL(new Blob([response.data]));
        //   const link = document.createElement('a');
        //   link.href = url;
        //   link.setAttribute('download', 'file1.xls');
        //   document.body.appendChild(link);
        //   link.click();
        // }).catch(err => {
        //   console.log('erro=====: ', err);
        // })

        this.showLoading = false;
      } else {
        console.log("else  =======: ", this.startDate, this.endDate);
      }
    }
  }
};
</script>
